import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import cls from 'classnames';
import { format } from 'date-fns';

import { MarkdownWithReadMore } from 'src/explore/elements/MarkdownWithReadMore';

import styles from './index.module.sass';

interface Props {
  active?: boolean;
  review: {
    authorLocation: string;
    authorName: string;
    content: string;
    createdOn: string;
  };
  reviewClass?: string;
  showDate?: boolean;
}

export const Review: React.FC<Props> = ({ active = true, review, reviewClass, showDate }) => {
  const { authorLocation, authorName, content, createdOn } = review;

  return (
    <div className="spec__review">
      <strong className={cls( styles.review, 'd-block mb-5 fs-5', reviewClass )}>
        <MarkdownWithReadMore max={250} text={content} />
      </strong>

      <div
        className={cls( styles.attribution, {
          [styles.active]: active,
        })}
      >
        <strong>{authorName}</strong>

        <div className={styles.details}>
          <span>{authorLocation}</span>

          {showDate && createdOn && <span>{format( new Date( createdOn ), 'MMMM dd, yyyy' )}</span>}

          <span>
            {'Verified Purchase '}
            <FontAwesomeIcon className={styles.check} icon={faCircleCheck} />
          </span>
        </div>
      </div>
    </div>
  );
};
